export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-pet-parent-37ab55293987378fecc07e767adeaf9e.png";